import { render, staticRenderFns } from "./GroupsFilter.vue?vue&type=template&id=18e3eade&scoped=true&"
import script from "./GroupsFilter.vue?vue&type=script&lang=js&"
export * from "./GroupsFilter.vue?vue&type=script&lang=js&"
import style0 from "./GroupsFilter.vue?vue&type=style&index=0&id=18e3eade&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e3eade",
  null
  
)

export default component.exports